import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AttendanceComponent } from './components/attendance/attendance.component';
import { DailySummaryComponent } from './components/daily-summary/daily-summary.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DateSelectorComponent } from './components/date-selector/date-selector.component';
import { FeeSummaryComponent } from './components/fee-summary/fee-summary.component';
import { LineGraphComponent } from './components/line-graph/line-graph.component';
import { NoticesComponent } from './components/notices/notices.component';
import { SubjectWiseSummaryComponent } from './components/subject-wise-summary/subject-wise-summary.component';
import { TeachersCommentsComponent } from './components/teachers-comments/teachers-comments.component';
import { TimeTableComponent } from './components/time-table/time-table.component';
import { DashboardService } from './services/dashboard.service';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { AuthorizationModule } from '../../authorization/authorization.module';
import { SlickSliderModule } from '../../shared/slick-slider/slick-slider.module';
import { ImageModule } from '../../shared/image/image.module';
import { MobileDashboardComponent } from './components/mobile-dashboard/mobile-dashboard.component';
import { TruncatePipeModule } from '../../shared/pipes/truncate.pipe';
import { MobileTimeTableComponent } from './components/mobile-time-table/mobile-time-table.component';
import { MobileDailySummaryComponent } from './components/mobile-daily-summary/mobile-daily-summary.component';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { InitialsPipeModule } from '../../shared/pipes/initials.pipe';
import { MobileTeachersCommentsComponent } from './components/mobile-teachers-comments/mobile-teachers-comments.component';
import { MobileAttendanceComponent } from './components/mobile-attendance/mobile-attendance.component';
import { HomeworksModule } from '../homeworks/homeworks.module';
import { OnlineExamsComponent } from './components/online-exams/online-exams.component';
import { OnlineMeetingsModule } from '../online-meetings/online-meetings.module';
import { UpcomingOnlineMeetingsComponent } from './components/upcoming-online-meetings/upcoming-online-meetings.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    AuthorizationModule,
    ImageModule,
    TruncatePipeModule,
    NgCircleProgressModule.forRoot({
      lazy : false
    }),
    SlickSliderModule,
    SwiperModule,
    InitialsPipeModule,
    HomeworksModule,
    OnlineMeetingsModule
  ],
  declarations: [DashboardComponent,
    NoticesComponent,
    FeeSummaryComponent,
    AttendanceComponent,
    SubjectWiseSummaryComponent,
    TeachersCommentsComponent,
    TimeTableComponent,
    LineGraphComponent,
    DateSelectorComponent,
    DailySummaryComponent,
    MobileDashboardComponent,
    MobileTimeTableComponent,
    MobileDailySummaryComponent,
    MobileTeachersCommentsComponent,
    MobileAttendanceComponent,
    OnlineExamsComponent,
    UpcomingOnlineMeetingsComponent],
  exports: [SubjectWiseSummaryComponent],
  providers: [DashboardService]
})
export class DashboardModule { }
